export enum ConnectionLogEventType {
    CONNECTED = "connected",
    DISCONNECTED = "disconnected"
};

export interface ConnectionLogSummaryRequestBody {
    startDate: string;
    endDate: string;
    event: ConnectionLogEventType;
    groupId?: string;
    limit?: number;
};